import { render, staticRenderFns } from "./update-aisle.vue?vue&type=template&id=355090a3&"
import script from "./update-aisle.vue?vue&type=script&lang=ts&"
export * from "./update-aisle.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports